<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="loaded ? (('Request ' | translate) + (pro?.first_name | translate)) : ''"
      [closeButton]="!(cameFromBookJob || cameFromEditRequest)"
      (closeItemAction)="goToMyPros()"
      [canGoBack]="cameFromBookJob || cameFromEditRequest"
      id="top-nav-height" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled right-side-extra-bottom-padding' : ''">

    @if (loaded && !isRightSideContent && !windowService.isDesktopRes) {
      <tidy-wrapper>
        <tidy-grid>
          <ion-row>
            <ion-col size="10">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/icons/number_1_white.svg'"
                  class="body-size" />
                <tidy-text
                  [actionBody]="(service?.title | titlecase) || 'Select Service '"
                  class="white" />
                <tidy-text
                  [actionBody]="frequencyName ? (('&nbsp- ' | translate) + (frequencyName | translate)) : ''"
                  class="white" />
              </tidy-row>
              <tidy-row class="vertical-align-center extra-bottom-padding">
                <tidy-image
                  [src]="'assets/img/icons/number_2_white.svg'"
                  class="body-size" />
                <tidy-text
                  [actionBody]="getMobileTimeTitle()"
                  class="white" />
              </tidy-row>
            </ion-col>
            <ion-col size="2" class="vertical-align-center">
              @if (frequencyName && serviceHasPrice()) {
                <tidy-row class="extra-left-padding">
                  <tidy-text
                    [title]="bookJobService.getDisplayPriceForJob(planId, service, selectedFrequency, choseFrequency, bookingType, hasNonTrialPaidSubscription, priceExperiment, bookingExperiment, customFlowName, pro?.private)"
                    class="green text-price" />
                </tidy-row>
              }
            </ion-col>
          </ion-row>
        </tidy-grid>
        <tidy-button
          [text]="'Review Request'"
          [action]="boundSubmit"
          [disabled]="form.invalid || selectedTimes?.length == 0"
          class="primary" />
      </tidy-wrapper>
    }

    @if (loaded) {
      @if (jobCard?.template === 'pending_availability_request') {
        <tidy-card>
          <!--CRAF Template / Pending request_type-->
          @if (jobCard?.template_data?.request_type === 'pending') {
            <tidy-row class="extra-bottom-padding vertical-align-center">
              <tidy-image
                [src]="'assets/icon/searching.svg'"
                class="header-size wiggle-animation" />
              <tidy-text
                [header]="'Request Pending'" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="requests.getProRequestBody(jobCard)" />
            </tidy-row>
            @for (day of requests.buildRequestTimeList(jobCard?.template_data?.availability_request?.request_times); track day) {
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="day" />
              </tidy-row>
            }
            @if (jobCard?.template_data?.job?.is_private) {
              <tidy-row class="extra-bottom-padding">
                <tidy-button
                  [text]="'Assign Pro'"
                  [action]="goToChangePro.bind(this, jobCard)"
                  class="primary" />
              </tidy-row>
            }
            <tidy-row [align]="'center'" class="extra-top-padding">
              <tidy-text
                (action)="cancelProRequest(jobCard?.template_data?.availability_request)"
                [body]="'Cancel Request'"
                class="link" />
            </tidy-row>
            @if (bookingFormAnswers?.length > 0) {
              <tidy-row class="extra-top-padding extra-bottom-padding">
                <tidy-divider />
              </tidy-row>
              <tidy-row class="vertical-align-center extra-bottom-padding">
                <tidy-image
                  [src]="'assets/img/information.svg'"
                  class="header-size" />
                <tidy-text
                  [header]="'Job Note'" />
              </tidy-row>
              @for (answer of bookingFormAnswers; track answer) {
                @if (answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area') {
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label + ': ' + answer?.data?.value" />
                  </tidy-row>
                  @if (answer?.template_input?.image_url) {
                    <tidy-photo-note
                      [src]="answer?.template_input?.image_url" />
                  }
                }
                @if (answer?.template_input?.type == 'select') {
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label + ': ' + me.getBookingFormSelectValue(answer?.data?.value)" />
                  </tidy-row>
                  @if (answer?.template_input?.image_url) {
                    <tidy-photo-note
                      [src]="answer?.template_input?.image_url" />
                  }
                }
                @if (answer?.template_input?.type == 'multiselect') {
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label + ': ' + me.getBookingFormMultiselectValue(answer?.data?.value)" />
                  </tidy-row>
                  @if (answer?.template_input?.image_url) {
                    <tidy-photo-note
                      [src]="answer?.template_input?.image_url" />
                  }
                }
                @if (answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image') {
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label" />
                  </tidy-row>
                  <tidy-carrousel
                    class="photo-notes-carrousel only-padding-bottom"
                    [scaleImages]="true">
                    <tidy-photo-note
                      *tidyCarrousel
                      [src]="answer?.data?.value" />
                  </tidy-carrousel>
                }
                @if (answer?.template_input?.type == 'files'  && answer?.template_input?.data?.type == 'images') {
                  <tidy-row>
                    <tidy-text
                      [body]="answer?.template_input?.label" />
                  </tidy-row>
                  <tidy-carrousel
                    class="photo-notes-carrousel only-padding-bottom"
                    [scaleImages]="true">
                    @for (imageUrl of answer?.data?.value; track imageUrl) {
                      <tidy-photo-note
                        *tidyCarrousel
                        [src]="imageUrl" />
                    }
                  </tidy-carrousel>
                }
              }
            }
          }
          <!--CRAF Template / Countered request_type-->
          @if (jobCard?.template_data?.request_type === 'countered') {
            <tidy-row class="extra-bottom-padding vertical-align-center">
              <tidy-image
                [src]="'assets/img/request-counter.svg'"
                class="title-size" />
              <tidy-text
                [header]="jobCard?.template_data?.homekeeper?.homekeeper_name"
                [translate]="false" /><span>&nbsp;</span>
                <tidy-text
                  [header]="'Proposed Other Times'" />
              </tidy-row>
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="jobCard?.template_data?.homekeeper?.homekeeper_name"
                  [translate]="false" />
                <tidy-text
                  [body]="' indicated that they were not available for the times you requested, but provided other times they are available.'" />
              </tidy-row>
              <tidy-button
                [text]="'View Other Times'"
                [action]="goToRequestProCounter.bind(this, jobCard?.template_data?.availability_request, jobCard?.template_data?.homekeeper)"
                class="primary" />
            }
          </tidy-card>
        }
        <tidy-row>
          <tidy-text
            [title]="'Select Service'" /><br>
          @if (address?.address_name) {
            <tidy-text
              [body]="'@' + address?.address_name" />
          }
          @if (!address?.address_name) {
            <tidy-text
              [body]="'@' + address?.address1" />
            <tidy-text
              [body]="address?.address2 !== null ? ' ' + address?.address2 : ''" />
          }
        </tidy-row>
        @for (service of services; track service; let i = $index) {
          @if (showService(service)) {
            <tidy-card>
              <form [formGroup]="form" novalidate action="#">
                <tidy-card-button [hideArrow]="true" (action)="handleServiceClick(service)">
                  <tidy-row class="position-relative">
                    <tidy-grid>
                      <tidy-row>
                        <ion-row>
                          <ion-col size="10">
                            <tidy-radio-button
                              formControlName="service"
                              class="radio-card-title"
                              [form]="form.controls.service"
                              (optionChange)="selectService()"
                              [items]="[{value: service.key, viewValue: service.title | titlecase}]" />
                          </ion-col>
                          <tidy-image
                            class="width-60 height-60 justify-center position-absolute right-0 no-margin tranlate-y-10per"
                            [src]="service.image" />
                        </ion-row>
                      </tidy-row>
                    </tidy-grid>
                    <tidy-row>
                      <ion-row>
                        <ion-col size="10">
                          <tidy-text
                            [body]="bookJobService.getDisplayPriceForJob(planId, service, 'One Time', true, bookingType, hasNonTrialPaidSubscription, priceExperiment, bookingExperiment, customFlowName, pro?.private)" />
                          <tidy-text
                            [body]="service.description" />
                        </ion-col>
                      </ion-row>
                    </tidy-row>
                  </tidy-row>
                  @if (form.value.service === service.key && !addingOneTimeJob) {
                    <tidy-row>
                      <tidy-divider />
                    </tidy-row>
                    <tidy-row class="no-padding">
                      <tidy-radio-button
                        chunkSize="2"
                        formControlName="frequency"
                        (optionChange)="selectFrequency($event)"
                        [form]="form.controls.frequency"
                        [items]="getFrequencyItems(service.frequencies)" />
                    </tidy-row>
                  }
                </tidy-card-button>
              </form>
            </tidy-card>
          }
        }
        @if (didChooseService && !showMoreServices) {
          <tidy-row [align]="'center'" class="extra-bottom-padding">
            <tidy-text
              (action)="showServices()"
              [body]="'Show More Services'"
              class="link" />
          </tidy-row>
        }
        @if (isLoadingBookingForms) {
          <tidy-loader />
        }
        @if (bookingForms?.length > 0) {
          <tidy-card>
            <dynamic-booking-form
              #dynamicBookingForm
              [forms]="bookingForms"
              [submitted]="submitted"
              [hasImageUploadError]="hasImageUploadError"
              [isLoading]="isLoadingBookingForms"
              (attachmentsChange)="onAttachmentsChange($event)"
              (selectedCheckboxesChange)="onSelectedCheckboxesChange($event)" />
          </tidy-card>
        }
        @if (!service?.isBasePriceAllowedToBook && didChooseFrequency) {
          <tidy-alert>
            <tidy-row class="extra-bottom-padding">
              <tidy-image
                [src]="'assets/img/request-failed.svg'"
                class="header-size" />
              <tidy-text
                [header]="'Your Price Is Low'" />
            </tidy-row>
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="'Your price for this service is lower than the pro\’s price so it is less likely they will accept your request. You can keep your price the same or increase it.'" />
            </tidy-row>
            <tidy-button
              [text]="('Change My Rate to ' | translate) + (service?.prices?.lowestPossibleBasePrice | tcurrency)"
              [action]="boundChangeServiceRates"
              [disabled]="form.invalid"
              class="primary" />
          </tidy-alert>
        }
        <tidy-row>
          <tidy-text
            [title]="'Select Time(s)'" />
          @if (didChooseFrequency) {
            <br>
              <tidy-text
                [body]="pro?.first_name" />
              <tidy-text
                [body]="' can counter with other times.'"
                [translate]="false" />
            }
          </tidy-row>
          @if (notSelectedTimesError) {
            <tidy-error-message
              [text]="'Please select a time.'" />
          }
          @if (isLoadingTimes) {
            <tidy-loader
              />
          }
          @if (!didChooseFrequency && !isLoadingTimes) {
            <tidy-alert>
              <tidy-row>
                <tidy-text
                  [body]="'Select service to see times'" />
              </tidy-row>
            </tidy-alert>
          }
          @if (didChooseFrequency && !isLoadingTimes) {
            @if (requestableDays?.length == 0) {
              <tidy-alert>
                <tidy-row>
                  <tidy-text
                    [body]="'Unfortunately '" />
                  <tidy-text
                    [body]="pro?.first_name"
                    [translate]="false" />
                  <tidy-text
                    [body]="' cannot be requested at this time.'" />
                </tidy-row>
              </tidy-alert>
            }
            @for (day of requestableDays; track day; let dayIndex = $index) {
              <tidy-card>
                <tidy-row class="vertical-align-center">
                  <ng-container [formGroup]="weekDayCheckBox[dayIndex]">
                    <tidy-checkbox
                      [items]="[{viewValue: day?.displayFormat, value: true}]"
                      (checkedChange)="markCheckbox($event, dayIndex)"
                      formControlName="checked"
                      [checked]="weekDayCheckBox[dayIndex].value.checked"
                      [initValue]="weekDayCheckBox[dayIndex].value.checked" />
                  </ng-container>
                </tidy-row>
                @for (formGrp of timeRangeForms[dayIndex]; track formGrp; let i = $index) {
                  <tidy-two-column-row [formGroup]="formGrp" style="padding-top: 15px;">
                    <tidy-select
                      style="max-width: 35%; margin: 0;"
                      [icon]="'assets/svg/time.svg'"
                      [label]="'Time'"
                      [form]="formGrp.controls.start_time"
                      formControlName="start_time"
                      errorMessage="Select a valid time"
                      [submitted]="true"
                      (optionChange)="updateValuesValidity(dayIndex); startTimeChange(formGrp)"
                      [items]="dayIndex === todayIndex ? todayStartOpts : timeOpts" />
                    <span style="align-self: center; justify-content: space-around; max-width: 10%;">-</span>
                    <tidy-select
                      style="max-width: 35%; margin-right: 10px;"
                      [icon]="'assets/svg/time.svg'"
                      [label]="'Time'"
                      [form]="formGrp.controls.end_time"
                      formControlName="end_time"
                      errorMessage="Select a valid time"
                      [submitted]="true"
                      (optionChange)="updateValuesValidity(dayIndex)"
                      [items]="endTimes(formGrp.value.start_time)" />
                    <tidy-image (action)="removeTimeRange(dayIndex, i)" src="assets/img/trash-icon-outline.svg" class="icon body-size" style="max-width: 16px; align-self: center;" />
                    <tidy-image (action)="addNewTimeRange(dayIndex)" src="assets/img/add.svg" class="icon body-size" style="max-width: 16px; align-self: center; opacity: .6; margin-left: auto;" />
                  </tidy-two-column-row>
                }
              </tidy-card>
            }
          }
        }
      </tidy-wrapper>
    </ng-template>

    <ng-template #rightColumn>
      @if (loaded && didChooseService && windowService.isDesktopRes) {
        <tidy-wrapper class="custom-right-column">
          <tidy-row [align]="isRightSideContent ? 'left' : 'center'">
            <tidy-text
              [title]="(service?.title | titlecase) || 'Select Service'" />
          </tidy-row>
          <tidy-row class="vertical-align-center">
            <tidy-image
              [src]="'assets/svg/refresh-circle.svg'"
              class="body-size" />
            <tidy-text
              [body]="frequencyName || 'Select Frequency'" />
          </tidy-row>
          @if (service?.price !== '') {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/card.svg'"
                class="body-size" />
              @if (frequencyName && serviceHasPrice() && service?.billingType !== 'price_later' && service?.billingType !== 'hourly' && service?.price) {
                <tidy-text
                  [body]="service?.price | tcurrency" />
              }
              @if (frequencyName && serviceHasPrice() && service?.billingType == 'hourly') {
                <tidy-text
                  [body]="(service?.price | tcurrency) + ('/hr' | translate)" />
              }
              @if (service?.billingType == 'price_later' || !service?.price) {
                <tidy-text
                  [body]="'Priced later'" />
              }
            </tidy-row>
          }
          @if (selectedTimes.length > 0) {
            <tidy-row class="vertical-align-center">
              <tidy-image
                [src]="'assets/svg/calendar.svg'"
                class="body-size" />
              <tidy-text
                [body]="'Requested Times:'" />
            </tidy-row>
            @for (time of requests.buildRequestTimeRangeList(selectedTimes); track time) {
              <tidy-row class="extra-bottom-padding">
                <tidy-text
                  [body]="time" />
              </tidy-row>
            }
          }
          <tidy-button
            [text]="'Review Request'"
            [action]="boundSubmit"
            [disabled]="form.invalid || selectedTimes?.length == 0"
            class="primary" />
        </tidy-wrapper>
      }
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [style.padding-top.px]="topNavHeight" [templateRightColumn]="rightColumn" [templateContent]="content" />
    }

    <ng-template #reviewBooking>
      <tidy-wrapper class="custom-right-column black-column">
        <tidy-grid>
          <ion-row>
            <ion-col size="10">
              <tidy-row class="vertical-align-center">
                <tidy-image
                  [src]="'assets/img/icons/number_1_white.svg'"
                  class="body-size" />
                <tidy-text
                  [actionBody]="(service?.title | titlecase) || 'Select Service '"
                  class="white" />
                <tidy-text
                  [actionBody]="frequencyName ? (('&nbsp- ' | translate) + (frequencyName | translate)) : ''"
                  class="white" />
              </tidy-row>
              <tidy-row class="vertical-align-center extra-bottom-padding">
                <tidy-image
                  [src]="'assets/img/icons/number_2_white.svg'"
                  class="body-size" />
                <tidy-text
                  [actionBody]="getMobileTimeTitle()"
                  class="white" />
              </tidy-row>
            </ion-col>
            <ion-col size="2" class="vertical-align-center">
              @if (frequencyName && serviceHasPrice()) {
                <tidy-row class="extra-left-padding">
                  <tidy-text
                    [title]="bookJobService.getDisplayPriceForJob(planId, service, selectedFrequency, choseFrequency, bookingType, hasNonTrialPaidSubscription, priceExperiment, bookingExperiment, customFlowName, pro?.private)"
                    class="green text-price" />
                </tidy-row>
              }
            </ion-col>
          </ion-row>
        </tidy-grid>

        <tidy-button
          [text]="'Review Request'"
          [action]="boundSubmit"
          [disabled]="form.invalid || selectedTimes?.length == 0"
          class="primary" />
      </tidy-wrapper>
    </ng-template>

    @if (isRightSideContent) {
      <div class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="reviewBooking" />
      </div>
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
